import React, {Component} from "react"
import PropTypes from "prop-types"

import {RouterLink} from "@irati/ui/src/Link"
import FormattedMessage from "@irati/utils/lang"

import {EmptyData} from "../../EmptyData"

interface Props {}

class EmptyPolls extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {apps} = this.context
    return (
      <EmptyData text="admin.reporting.polls.empty.text">
        <RouterLink to="/" app={apps.RECOGNITION}>
          <FormattedMessage id="admin.reporting.polls.empty.link" />
        </RouterLink>
      </EmptyData>
    )
  }
}

export default EmptyPolls
